/* Regenis: internal-video component graft (2026-07-15).
   This Shrine build ships <internal-video> markup (homepage + PDP testimonial
   videos) but no script ever defines the element -- the play buttons did
   nothing, ever. Minimal owner: play button starts playback (with sound;
   falls back to muted if the browser blocks it), tapping the video toggles
   play/pause, button + native controls state kept coherent. Honors
   data-autoplay="true" (muted, in-viewport). */
(function () {
  function wire(iv) {
    if (iv.__rgv) return;
    iv.__rgv = true;
    var v = iv.querySelector('video');
    if (!v) return;
    var btn = iv.querySelector('.internal-video__play');

    function reflect() {
      if (btn) btn.style.display = v.paused ? '' : 'none';
      iv.classList.toggle('is-playing', !v.paused);
    }
    function start(unmuted) {
      if (unmuted) v.muted = false;
      var p = v.play();
      if (p && p.catch) p.catch(function () {
        v.muted = true;
        var q = v.play();
        if (q && q.catch) q.catch(function () {});
      });
    }
    v.controls = false;
    v.setAttribute('controlslist', 'nodownload nofullscreen noplaybackrate noremoteplayback');
    v.setAttribute('disablepictureinpicture', '');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      start(true);
    });
    v.addEventListener('click', function () {
      if (v.paused) start(false); else v.pause();
    });
    v.addEventListener('play', reflect);
    v.addEventListener('pause', reflect);
    v.addEventListener('ended', function () { reflect(); });

    if (iv.dataset.autoplay === 'true') {
      try {
        new IntersectionObserver(function (es, o) {
          es.forEach(function (en) {
            if (en.isIntersecting) { v.muted = true; start(false); o.disconnect(); }
          });
        }, { threshold: 0.4 }).observe(iv);
      } catch (e) {}
    }
    reflect();
  }
  function init() { [].slice.call(document.querySelectorAll('internal-video')).forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
